import Api from 'services/api'
import BaseModel from './BaseModel'
import _ from 'underscore'

export const defaultGroupMetric = {
  name: '',
  description: '',
  callToAction: [],
  metrics: [],
  draft: true,
  unit: '',
  range: '',
  groupId: 0
}

class GroupMetricModel extends BaseModel {
  constructor (options = defaultGroupMetric) {
    super(options || defaultGroupMetric)
    Object.seal(this)
  }

  save (group, trends, metrics, saveMethod, onSaveSuccessCallback, onSaveFailCallback, onValidationErrorCallback) {
    const errors = { ...this._validate(group, trends, metrics) }

    if (_.isEmpty(errors)) {
      return Api.DeviceMetrics[saveMethod === 'create' ? 'createGroupMetric' : 'updateGroupMetric'](group)
        .then(() => {
          onSaveSuccessCallback()
        })
        .catch(() => {
          onSaveFailCallback()
        })
    } else {
      onValidationErrorCallback(errors)
    }
  }

  delete (onDeleteSuccessCallback, onDeleteFailCallback, groupId) {
    return Api.DeviceMetrics.deleteGroupMetric(groupId)
      .then(() => {
        onDeleteSuccessCallback()
      })
      .catch(async (error) => {
        if (error.status === 400) {
          const errorResponse = await error.json()
          onDeleteFailCallback(errorResponse?.base[0].name)
        } else {
          onDeleteFailCallback('Delete Failed')
        }
      })
  }

  _validate (attributes, trends, metrics) {
    const isPublished = () => {
      return trends.filter((trend) => !trend.draft && trend.groupList.filter((group) => group.id === attributes.id))
    }

    const errors = {}
    if (!attributes.name) {
      errors['name'] = 'Name is required'
    }

    if (attributes.draft && !_.isEmpty(isPublished())) {
      errors['draft'] = `Draft status cannot be changed while group is in a published trend (${isPublished()[0].name})`
    }

    if (!attributes.unit) {
      errors['unit'] = 'Unit is required'
    }

    if (!attributes.description) {
      errors['description'] = 'Description is required'
    }

    if (_.isEmpty(attributes.metrics) || attributes.metrics.length <= 1) {
      errors['metrics'] = 'Select At least two metrics required'
    } else {
      const metricIds = attributes.metrics.map(item => item.metricId)
      const isDraftTrue = metrics.some(metric => metricIds.includes(metric.id) && metric.draft)
      if (isDraftTrue && !attributes.draft) {
        errors['metrics'] = 'Cannot publish group with metrics in draft'
      }
    }

    if (_.isEmpty(attributes.range)) {
      errors['range'] = 'Recommended Range is required'
    }

    return errors
  }
}

export default GroupMetricModel
